import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import isServer from "./isServer";

const appVersion = process.env.NEXT_PUBLIC_BUGSNAG_APP_VERSION;
const releaseStage = process.env.NEXT_PUBLIC_BUGSNAG_RELEASE_STAGE;
const enabledReleaseStages = ["development", "production"];

if (!isServer()) {
  Bugsnag.start({
    apiKey: "b9250a990575975b03a9ead2ba2899a4",
    plugins: [new BugsnagPluginReact()],
    appVersion,
    releaseStage,
    enabledReleaseStages,
  });
}
